<template>
  <section>
    <div
      v-if="store.getters.getUnidades.length > 0"
      class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
    >
      <div
        class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white sticky left-0"
      >
        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable
        :data="filteredData"
        @delete="deleteUnidade"
        @edit="findUnidadeById"
      >
        <template #head>
          <th scope="col" class="px-6 py-3">Empresa</th>
          <th scope="col" class="px-6 py-3">Cidade</th>
          <th scope="col" class="px-4 py-3">Estado</th>
          <th scope="col" class="px-4 py-3 text-center">#</th>
        </template>
      </DataTable>
    </div>

    <NoDataAnim v-else :label="'Nenhuma unidade cadastrada'" />
  </section>
</template>

<script setup>
import DataTable from "./../../components/_partials/DataUnidadeTable.vue";
import SearchInput from "@/components/Tables/SearchInput.vue";
import NoDataAnim from "@/components/Lotties/NoDataAnim.vue";
import RcdService from "../../service/rcd.service";
import { showToast as toast } from "@/helpers/UseToasts";
import { computed, onMounted, ref } from "vue";
import { initFlowbite } from "flowbite";
import { dataRcd } from "../../store";
import { storeApp } from "@/store";

const store = dataRcd;
const searchTerm = ref("");

const dataTable = computed(() => store.getters?.getUnidades);

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable.value.filter((row) => {
    const matchesSearch =
      !searchTerm.value ||
      ["unidade", "cidade", "estado"].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesSearch;
  });
});

async function deleteUnidade(id) {
  storeApp.state.loading = true;
  const confirm = window.confirm("Deseja realmente remover esta unidade?");
  if (confirm) {
    await RcdService.destroyUnidade(id)
      .then((res) => {
        storeApp.state.loading = false;

        if (res?.data?.success) {
          dataRcd.dispatch("setUnidades", res?.data?.unidades);

          return toast("Sucesso", res?.data?.message, "success");
        }
      })
      .catch((err) => {
        storeApp.state.loading = false;

        if (err?.response?.data?.error) {
          return toast("Aviso", err.response.data.message, "error");
        }

        return toast("Aviso", "Algo deu errado ao remover unidade", "error");
      });
  }
  storeApp.state.loading = false;
}

async function findUnidadeById(id) {
  storeApp.state.loading = true;
  await RcdService.getUnidadeById(id)
    .then((res) => {
      if (res.data.unidade) {
        dataRcd.state.unidadeForm.id = res.data.unidade.id;
        dataRcd.state.unidadeForm.unidade = res.data.unidade.unidade;
        dataRcd.state.unidadeForm.cidade = res.data.unidade.cidade;
        dataRcd.state.unidadeForm.estado = res.data.unidade.estado;
      }
    })
    .catch((err) => {
      return toast(
        "Aviso",
        "Algo deu errado ao buscar dados da unidade",
        "error"
      );
    });

  dataRcd.dispatch("setComponentActiveUpdateUnidade");
  storeApp.state.loading = false;
}

onMounted(() => {
  initFlowbite();
});
</script>
